import * as ng from 'angular';
import { StateService } from '@uirouter/angularjs';

export class AnonShellController {
   static $inject = ['$state', 'session'];

   constructor(
      private $state: StateService,
      private session
   ) { }

   get showGraphic() {
      return this.$state.current.name == 'login';
   }

   get version() {
      return this.session.appVersion();
   }
}

ng.module('e360').component('anonShell', {
   templateUrl: require('./anon-shell.html'),
   controller: AnonShellController
});
